import { render, staticRenderFns } from "./BlogView.vue?vue&type=template&id=2f961359&"
import script from "./BlogView.vue?vue&type=script&lang=ts&"
export * from "./BlogView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports